<template>
  <v-card>
    <vue-card-title
      :title="'Manage Product & Services'"
      :subtitle="
        'Refer to the following information to manage the product & services.'
      "
      :icon="$getIcon('mdiClipboardTextOutline')"
    >
      <template slot="actions">
        <v-btn
          class="indigo accent-2 white--text text-capitalize my-0"
          small
          @click="productServiceForm = true"
        >
          Create Product/Service
        </v-btn>
      </template>
    </vue-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-row>
        <v-col md="4">
          <v-treeview
            v-if="serviceCategoryAndProducts.length > 0"
            :active.sync="active"
            :items="serviceCategoryAndProducts"
            activatable
            open-on-click
            open-all
            hoverable
          ></v-treeview>
          <div v-else>
            Please add product/service to continue.
          </div>
        </v-col>
        <v-col md="8">
          <vue-default-svg-loader
            v-if="!fetchedServiceDetail"
          ></vue-default-svg-loader>
          <v-card v-else-if="active.length > 0 && fetchedServiceDetail">
            <vue-card-title
              :title="serviceDetail.name"
              :subtitle="
                serviceDetail.service_type +
                  ` -- Per Price: ` +
                  serviceDetail.per_price
              "
            >
              <template slot="actions">
                <a
                  class="caption blue--text"
                  @click="
                    (productServiceForm = true) &&
                      (selectedProductServiceData = serviceDetail)
                  "
                  >Update</a
                >
              </template>
            </vue-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-data-table
                :items="serviceDetail.sales_stages"
                class="elevation-1"
                hide-default-header
                hide-default-footer
              >
                <template v-slot:item="salesStageProps">
                  <tr>
                    <td width="20%">
                      <div class="d-flex">
                        <div>
                          {{ salesStageProps.item.name }}
                          <small class="grey--text d-inline-flex"
                            >({{ salesStageProps.item.stage_type }})</small
                          >
                        </div>
                        <div class="text-right">
                          <v-spacer></v-spacer>
                          <a
                            @click="
                              (productServiceSubStageForm = true) &&
                                (selectedStage = salesStageProps.item.name) &&
                                (selectedStageId = salesStageProps.item.id) &&
                                (selectedProductServiceData = serviceDetail)
                            "
                          >
                            <v-icon small v-text="$getIcon('mdiPlus')">
                            </v-icon>
                            Create Sub Stage of {{ serviceDetail.service_type }}
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="20%" style="padding: 0px !important;">
                      <v-data-table
                        :items="salesStageProps.item.sub_stages"
                        class="elevation-0"
                        hide-default-header
                        hide-default-footer
                      >
                        <template v-slot:item="props">
                          <tr>
                            <td width="10%"></td>
                            <td>
                              <div
                                v-if="props.item.service"
                                style="margin-left: 40px;"
                              >
                                <small>{{ props.item.order }}.</small>
                                {{ props.item.name }}
                                <small
                                  v-if="props.item.is_process"
                                  class="d-block grey--text mx-2"
                                  >Process</small
                                >
                                <small v-else class="d-block grey--text mx-2"
                                  >Communication</small
                                >
                              </div>
                              <div v-else>
                                <small>{{ props.item.order }}.</small>
                                {{ props.item.name }}
                                <small
                                  v-if="props.item.is_process"
                                  class="d-block grey--text mx-2"
                                  >Process</small
                                >
                                <small v-else class="d-block grey--text mx-2"
                                  >Communication</small
                                >
                              </div>
                            </td>
                            <td>
                              <v-icon
                                v-if="props.item.service"
                                class="caption btn-tny pa-1"
                                @click="
                                  (selectedProductServiceSubStageData =
                                    props.item) &&
                                    (productServiceSubStageForm = true) &&
                                    (selectedStage =
                                      salesStageProps.item.name) &&
                                    (selectedProductServiceData = serviceDetail)
                                "
                                v-text="$getIcon('mdiPencil')"
                              ></v-icon>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <v-card v-else>
            <vue-no-data
              text="Please select any service to view its sub stages."
            ></vue-no-data>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- Product Service Form -->
    <v-bottom-sheet v-model="productServiceForm" scrollable>
      <v-card tile>
        <vue-card-title
          :display-card.sync="productServiceForm"
          :title="cardTitle"
          :subtitle="'Fill up the following form to action on product/service.'"
          :icon="$getIcon('mdiFileDocumentEdit')"
          closable
          @close="productServiceForm = false"
        >
        </vue-card-title>
        <v-divider></v-divider>
        <v-card-text class="form-scroll scrollable">
          <product-service-form
            v-if="selectedProductServiceData && productServiceForm"
            :action-data="selectedProductServiceData"
            @productServiceFormResponse="formSuccess"
          >
          </product-service-form>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
    <!-- / Product Service Form -->

    <!-- Product / Service Sub Stage Form -->
    <v-bottom-sheet v-model="productServiceSubStageForm" scrollable>
      <v-card tile>
        <vue-card-title
          :display-card.sync="productServiceSubStageForm"
          :title="cardTitleProductServiceSubStage"
          :subtitle="
            'Fill up the following form to action on product/service sub stage.'
          "
          :icon="$getIcon('mdiClipboardTextOutline')"
          closable
          @close="productServiceSubStageForm = false"
        >
        </vue-card-title>
        <v-divider></v-divider>
        <v-card-text class="form-scroll scrollable">
          <sales-sub-stage-form
            v-if="
              selectedProductServiceSubStageData &&
                productServiceSubStageForm &&
                selectedProductServiceData
            "
            :action-data="selectedProductServiceSubStageData"
            :selected-stage="selectedStage"
            :selected-stage-id="selectedStageId"
            :selected-service="selectedProductServiceData"
            service-sub-stage
            @productServiceSubStageFormResponse="
              formSuccessProductServiceSubStage
            "
          >
          </sales-sub-stage-form>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
    <!-- / Product / Service Sub Stage Form -->
  </v-card>
</template>
<script>
import ProductServiceForm from "@/components/crm/configuration/product_and_services/ProductAndServicesForm";
import SalesSubStageForm from "@/components/crm/configuration/sales_stage/forms/SalesSubStageForm";

export default {
  components: {
    SalesSubStageForm,
    ProductServiceForm
  },
  data() {
    return {
      fetched: false,
      fetchedServiceDetail: true, // intended
      productServiceForm: false,
      active: [],
      open: [],
      serviceDetail: {},
      serviceCategoryAndProducts: [],
      // form
      cardTitle: "",
      selectedProductServiceData: {},
      // product sub stage form
      selectedStage: "",
      selectedStageId: "",
      productServiceSubStageForm: false,
      cardTitleProductServiceSubStage: "",
      selectedProductServiceSubStageData: {},
      organizationSlug: this.$store.state.shell.currentOrganizationId
    };
  },
  watch: {
    productServiceForm(newVal) {
      if (Object.keys(this.selectedProductServiceData).length > 0 && newVal) {
        this.cardTitle = "Update Product/Service";
      } else {
        this.selectedProductServiceData = {};
        this.cardTitle = "Create Product/Service";
      }
    },
    productServiceSubStageForm(newVal) {
      if (
        Object.keys(this.selectedProductServiceSubStageData).length > 0 &&
        newVal
      ) {
        this.cardTitleProductServiceSubStage =
          "Update Product / Service Sub Stage";
      } else {
        this.selectedProductServiceSubStageData = {};
        this.cardTitleProductServiceSubStage =
          "Create Product / Service Sub Stage";
      }
    },
    active(val) {
      if (val.length > 0) {
        this.fetchServiceDetail(val[0]);
      }
    }
  },
  created() {
    this.fetchServiceCategoryAndProducts();
  },
  methods: {
    fetchServiceCategoryAndProducts() {
      const productServiceAPI = `/api/v1/crm/service-categories/?organization__slug=${this.organizationSlug}`;
      this.fetched = false;
      this.$axios.$get(productServiceAPI).then(response => {
        this.serviceCategoryAndProducts = response.results;
        this.fetched = true;
      });
    },
    fetchServiceDetail(serviceDetailId) {
      const productServiceDetailAPI = `/api/v1/crm/services/${serviceDetailId}/?organization__slug=${this.organizationSlug}`;
      this.fetchedServiceDetail = false;
      this.$axios.$get(productServiceDetailAPI).then(response => {
        this.serviceDetail = response;
        this.fetchedServiceDetail = true;
      });
    },
    formSuccess(updatedID) {
      if (updatedID !== "created") {
        this.fetchServiceDetail(updatedID);
      }
      this.productServiceForm = false;
      this.fetchServiceCategoryAndProducts();
    },
    formSuccessProductServiceSubStage() {
      this.fetchServiceDetail(this.selectedProductServiceData.id);
      this.productServiceSubStageForm = false;
      this.fetchServiceCategoryAndProducts();
    }
  }
};
</script>
